import {PanelSection} from "../../contenful/types";
import {useState} from "react";
import {Carousel} from "react-bootstrap";
import "./styles/CarouselPanelComponent.scss";
import {StyledTextComponent} from "./HeroBannerTwoColumnsComponent";

export const CarouselPanelComponent = (props : { section : PanelSection}) => {
    let [activeIndex, setActiveIndex] = useState(0);
    const handleSelect = (selectedIndex: number, e: any) => {
        setActiveIndex(selectedIndex);
    };

    let hasOverview = props.section.panels?.some(p => !!p.overview)
    return (
        <div className={"carousel-panel-component "  + (hasOverview ? "with-overview" : "")}>
            <div className={"carousel-panel-inner"}>
                <Carousel activeIndex={activeIndex} onSelect={handleSelect} controls={true}>
                    {props.section.panels?.map( (p,index) => {
                        return (
                            <Carousel.Item key={index}>
                                <div className={"carousel-banner"}>
                                    {p.styledTexts?.map(s => {
                                        return <StyledTextComponent key={s._id} st={s} />
                                    })}
                                    <div className={"carousel-banner-background"} style={{ backgroundImage : `url(${p.backgroundImage?.fields?.file?.url})`}}></div>
                                </div>
                            </Carousel.Item>
                        )
                    })}
                </Carousel>
                {hasOverview && (
                    <div className={"overview"}>
                        {props.section.panels?.map( (p,index) => {
                            return (
                                <div key={p._id} className={"overview-item-wrapper " + (activeIndex == index ? "active" : "")}>
                                    <div className={"overview-item-container"} key={index} onClick={()=>setActiveIndex(index)}>
                                        {props.section?.panels?.[index].icon && (
                                            <div className={"overview-icon"} style={{backgroundImage : `url(${props.section?.panels?.[index]?.backgroundImage?.fields?.file?.url})`}}>
                                                <img src={props.section?.panels?.[index]?.icon?.fields?.file?.url} />
                                            </div>
                                        )}
                                        <div className={"overview-item "+p.overview?.cssClassName}>
                                            <div className={"styled-text-container"}>
                                                {p.overview?.styledTexts?.map(st => (
                                                    <StyledTextComponent st={st} key={st._id}/>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}